export enum DashboardGroupByTypes {
    DATE_YEAR_MONTH_DAY_HOUR = "dateYearMonthDayHour",
    DATE_YEAR_MONTH_DAY = "dateYearMonthDay",
    DATE_YEAR_MONTH = "dateYearMonth",
    DATE_YEAR = "dateYear"
}